import { SET_PAGE, SetPageAction } from './actions';

export function createSetPageAction(payload: number): SetPageAction {
  return {
    type: SET_PAGE,
    payload,
  };
}
